import { Component } from '@angular/core';

@Component({
  selector: 'app-oms',
  templateUrl: './oms.component.html',
  styleUrls: ['./oms.component.scss'],
})
export class OmsComponent {

}
